import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Carrentalmumbai() {



const cardData = {
  keyword: " Car Rental Mumbai",

headingDescription:
  "Omshree Cab provides reliable and affordable car rental services in Mumbai for travelers who need convenient, comfortable, and flexible transportation across the city and beyond. Whether you are planning airport transfers, corporate travel, city sightseeing, family vacations, local commutes, or outstation trips, our Mumbai car rental service has a wide range of well‑maintained and air‑conditioned vehicles to suit your needs. We offer flexible booking options including one‑way rentals, round trips, hourly packages, full‑day plans, and long‑distance travel at transparent pricing with no hidden charges. Our fleet includes sedans, SUVs, luxury cars, multi‑purpose vehicles (MPVs) like Innova and Ertiga, and tempo travelers suitable for solo travelers, families, groups, and corporate clients. With professional chauffeurs familiar with Mumbai’s roads, punctual pickups from any location (including airports, railway stations, hotels, and residences), and 24/7 customer support, Omshree Cab makes car rental in Mumbai simple, comfortable, and stress‑free.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most iconic landmarks located on the waterfront in South Mumbai. Built during the British era, this historic arch monument attracts visitors for photography, sightseeing, and boat rides to Elephanta Island. The surrounding Colaba area also features cafes, heritage buildings, and street markets that draw travelers throughout the day. Renting a car in Mumbai makes it easy and comfortable to reach this famous destination without worrying about traffic or parking."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road along the Arabian Sea, popularly called the Queen’s Necklace because of the glittering lights at night. Visitors enjoy sunset views, evening walks, and the refreshing sea breeze while exploring this iconic boulevard. The route connects several key parts of South Mumbai, making it a favorite for city drives. Renting a car allows travelers to explore Marine Drive and nearby attractions comfortably and at their own pace."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is among Mumbai’s most popular beaches, known for its sandy shores, lively atmosphere, and tasty street food like pav bhaji, bhel puri, and pani puri. Tourists and locals alike visit to relax, take sunset photographs, and enjoy seaside walks. Renting a car in Mumbai provides a convenient way to reach Juhu Beach and nearby hotspots without the challenge of crowded public transport."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a revered Hindu shrine dedicated to Lord Ganesha and one of the city’s most visited spiritual sites. Devotees and tourists arrive from various regions to seek blessings and experience the temple’s serene environment. The temple attracts large crowds during festivals like Ganesh Chaturthi. A rented car ensures a smooth and comfortable trip to this popular destination while avoiding parking issues and traffic hassles."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is one of Mumbai’s most impressive modern landmarks, connecting Bandra and Worli across the Arabian Sea. This cable‑stayed bridge offers panoramic views of the sea and city skyline and is especially striking during sunset or at night when illuminated. Renting a car provides a smooth and enjoyable drive across the Sea Link while exploring other city attractions."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a popular mosque and shrine located on an islet off the coast of Mumbai, connected to the city by a narrow walkway visible during low tide. Visitors come for prayers, spiritual experiences, and sea views. Renting a car in Mumbai ensures easy and comfortable access to this unique spiritual spot without the stress of public transport."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock‑cut caves located on Elephanta Island and are known for their magnificent sculptures dedicated to Lord Shiva. Recognized as a UNESCO World Heritage Site, the caves attract tourists interested in history, culture, and architecture. Visitors typically take a ferry from the Gateway of India to reach the island. Renting a car makes it convenient to reach the ferry terminal and start the day trip smoothly."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large forest reserve within Mumbai offering trekking, nature walks, cycling, wildlife spotting, and visits to the historic Kanheri Caves. Nature lovers and families enjoy spending time in the lush greenery and exploring trails. Renting a car in Mumbai provides easy access and flexibility to plan a full‑day trip to this natural escape from the city."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a bustling shopping street in South Mumbai known for its vibrant markets, stalls, and local culture. Visitors enjoy browsing clothing, accessories, handicrafts, and souvenirs while sampling street food at nearby eateries. Renting a car ensures a comfortable trip to this lively marketplace and back, ideal for shopping and cultural exploration."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also called Pherozeshah Mehta Gardens, are terraced landscaped gardens located on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Visitors come for peaceful walks, photography, and relaxation in a serene environment. Renting a car makes it convenient to include this scenic spot in your Mumbai itinerary and explore nearby attractions with ease."
  }
],



services: [
{
name: "Car Rental Mumbai",
description: "Car rental in Mumbai provides convenient transportation options for passengers traveling within the city or planning outstation trips. Renting a car allows travelers to enjoy flexible schedules, comfortable seating, and reliable travel experiences. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for city sightseeing, airport transfers, business meetings, and family travel. Air-conditioned vehicles ensure comfortable journeys in all weather conditions. Flexible booking options allow passengers to reserve vehicles easily anytime."
},
{
name: "Car Hire Mumbai",
description: "Car hire in Mumbai offers reliable transportation services for individuals, families, and corporate travelers looking for comfortable travel solutions. Hiring a car allows passengers to travel conveniently across Mumbai and nearby destinations without worrying about driving or parking. Professional drivers ensure safe journeys and punctual pickup services across the city. Pickup is available from homes, offices, hotels, railway stations, and airport terminals. Ideal for sightseeing tours, airport transfers, and long-distance travel. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow convenient travel planning."
},
{
name: "Car Rental Service Mumbai",
description: "Car rental service in Mumbai provides dependable transportation solutions for passengers seeking comfortable and safe travel within the city or for outstation journeys. Rental services include a variety of vehicles suitable for business travel, tourism, and family trips. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for corporate travel, city tours, and airport transfers. Air-conditioned vehicles ensure comfortable travel experiences. Flexible booking options allow easy ride reservations."
},
{
name: "Self Drive Car Rental Mumbai",
description: "Self drive car rental in Mumbai offers convenient transportation for passengers who prefer to drive themselves while exploring the city or nearby destinations. Self drive vehicles provide privacy, flexibility, and freedom to travel according to personal schedules. Vehicles are well-maintained and suitable for city rides and highway travel. Pickup locations are available across major areas of Mumbai. Ideal for weekend trips, business visits, and personal travel plans. Comfortable vehicles ensure smooth driving experiences. Easy booking options allow travelers to reserve vehicles quickly."
},
{
name: "Luxury Car Rental Mumbai",
description: "Luxury car rental in Mumbai provides premium transportation services for passengers seeking stylish and comfortable travel experiences. Luxury vehicles offer spacious seating, elegant interiors, and smooth driving performance suitable for special occasions and business travel. Professional drivers ensure punctual pickup and safe journeys across Mumbai. Pickup services are available from hotels, homes, airports, and corporate offices. Ideal for VIP travel, corporate meetings, weddings, and airport transfers. Premium interiors ensure a comfortable and luxurious journey. Flexible booking options allow easy luxury vehicle reservations."
},
{
name: "Cheap Car Rental Mumbai",
description: "Cheap car rental in Mumbai offers affordable transportation solutions for passengers seeking budget-friendly travel options. Economical vehicles provide comfortable seating and reliable travel experiences suitable for city rides and short-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, railway stations, hotels, and airports. Ideal for students, tourists, and daily commuters. Air-conditioned vehicles ensure comfortable travel experiences. Flexible booking options allow convenient and economical ride reservations."
},
{
name: "Airport Car Rental Mumbai",
description: "Airport car rental in Mumbai provides convenient pickup and drop transportation services to and from airport terminals. Vehicles offer comfortable seating and luggage space suitable for passengers traveling with baggage. Professional drivers monitor flight schedules to ensure timely pickup and drop services. Pickup services are available from Mumbai airport terminals and city locations. Ideal for business travelers, tourists, and family airport transfers. Air-conditioned vehicles ensure comfortable travel experiences. Advance booking options allow passengers to schedule rides easily."
},
{
name: "Outstation Car Rental Mumbai",
description: "Outstation car rental in Mumbai offers comfortable transportation for passengers planning long-distance journeys outside the city. Vehicles are well-maintained and suitable for highway travel and extended trips. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for weekend trips, pilgrimage tours, and family vacations. Spacious seating ensures comfortable journeys. Flexible one-way and round-trip rental options allow easy travel planning."
},
{
name: "Car Rental Near Me Mumbai",
description: "Car rental near me in Mumbai helps passengers quickly locate nearby car rental services for convenient transportation. Rental services offer a range of vehicles suitable for city travel and outstation trips. Professional drivers ensure punctual pickup and safe driving services across nearby locations in Mumbai. Pickup services are available from homes, offices, hotels, and transport hubs. Ideal for family travel, airport transfers, and business trips. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow quick ride confirmations."
},
{
name: "Car Rental Booking Mumbai",
description: "Car rental booking in Mumbai allows passengers to reserve vehicles easily for city travel, airport transfers, and long-distance journeys. Online and phone booking options provide quick ride confirmation and convenient scheduling. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, tourism visits, and family trips. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow easy travel planning."
},
{
name: "Car Rental Per Km Mumbai",
description: "Car rental per km in Mumbai provides transparent pricing for passengers traveling within the city or planning outstation trips. Per kilometer pricing allows customers to pay based on distance traveled, making it economical for many travel needs. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business trips, airport transfers, and family travel. Comfortable vehicles ensure relaxed journeys. Clear pricing structure ensures affordable travel."
},
{
name: "Car Hire Service Mumbai",
description: "Car hire service in Mumbai offers reliable transportation for passengers looking for comfortable and professional travel solutions. Hiring a car allows passengers to travel easily across Mumbai and nearby cities without worrying about navigation or parking. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for corporate travel, family trips, and sightseeing tours. Comfortable interiors ensure relaxed journeys. Flexible booking options allow convenient ride scheduling."
},
{
name: "Corporate Car Rental Mumbai",
description: "Corporate car rental in Mumbai provides reliable transportation solutions for companies and business travelers. Vehicles offer comfortable seating and professional travel suitable for meetings, conferences, and airport transfers. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from offices, hotels, airports, and corporate hubs. Ideal for executive travel, employee transport, and corporate events. Comfortable vehicles ensure relaxed journeys for professionals. Flexible rental plans allow scheduled corporate travel."
},
{
name: "Family Car Rental Mumbai",
description: "Family car rental in Mumbai provides spacious and comfortable transportation ideal for families traveling together. Vehicles offer comfortable seating and luggage space suitable for city rides and long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, railway stations, and airport terminals. Ideal for vacations, sightseeing tours, and weekend trips. Comfortable interiors ensure enjoyable journeys for family members. Flexible booking options allow convenient ride reservations."
},
{
name: "Wedding Car Rental Mumbai",
description: "Wedding car rental in Mumbai provides stylish and elegant transportation services for weddings and special occasions. Luxury and premium vehicles offer comfortable seating and beautiful designs suitable for bridal entries and wedding ceremonies. Professional drivers ensure punctual arrival and smooth transportation services across Mumbai. Pickup services are available from homes, wedding venues, hotels, and banquet halls. Ideal for bridal cars, groom entry vehicles, and guest transportation. Premium interiors ensure memorable travel experiences. Flexible booking options allow advance reservations for special events."
}
],

tableData: [
["Car Rental Mumbai","Car Hire Mumbai"],
["Car Rental Service Mumbai","Self Drive Car Rental Mumbai"],
["Luxury Car Rental Mumbai","Cheap Car Rental Mumbai"],
["Airport Car Rental Mumbai","Outstation Car Rental Mumbai"],
["Car Rental Near Me Mumbai","Car Rental Booking Mumbai"],
["Car Rental Per Km Mumbai","Car Hire Service Mumbai"],
["Corporate Car Rental Mumbai","Family Car Rental Mumbai"],
["Wedding Car Rental Mumbai","Best Car Rental Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Wide Range of Rental Cars",
    WhyChoosedescription: "Omshree Cabs offers a wide range of car rental options in Mumbai including sedan cars like Swift Dzire and Etios, SUVs like Ertiga and Innova, and premium vehicles for comfortable city and outstation travel."
  },
  {
    WhyChooseheading: "Transparent Car Rental Pricing",
    WhyChoosedescription: "We provide clear and transparent pricing for car rentals in Mumbai. Customers receive complete information about per-kilometer rates, hourly packages, and additional charges before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Car Rental Service",
    WhyChoosedescription: "Our car rental service in Mumbai operates 24 hours a day. Whether you need a late-night airport pickup or early morning travel, Omshree Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are fully air-conditioned, regularly cleaned, and well maintained to provide passengers with a comfortable and safe travel experience."
  },
  {
    WhyChooseheading: "Flexible Rental Packages",
    WhyChoosedescription: "Customers can choose from multiple rental plans including hourly rentals, full-day packages, airport transfers, and outstation travel depending on their requirements."
  },
  {
    WhyChooseheading: "Professional Chauffeur Drivers",
    WhyChoosedescription: "Our experienced drivers are familiar with Mumbai’s roads, traffic routes, and highways. They ensure safe driving and a smooth journey for passengers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports across Mumbai so passengers can start their journey without any hassle."
  },
  {
    WhyChooseheading: "Trusted Car Rental Company",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for reliable car rental services in Mumbai because of our punctual service, comfortable vehicles, and professional customer support."
  }
]
};

const faqData = [
  { question: "Do you provide car rental services in Mumbai?", answer: "Yes, Omshree Cabs provides reliable car rental services in Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "Which cars are available for rental?", answer: "We offer sedan cars like Swift Dzire and Etios, SUVs like Ertiga and Innova, and premium vehicles depending on passenger requirements." },
  { question: "Is car rental available 24 hours in Mumbai?", answer: "Yes, our car rental service operates 24/7 for airport transfers, city travel, and outstation journeys." },
  { question: "Do you provide airport pickup and drop services?", answer: "Yes, we provide airport transfer services from Mumbai International Airport to various destinations." },
  { question: "Can I book a car for outstation travel?", answer: "Yes, we provide outstation car rental services from Mumbai to Pune, Nashik, Lonavala, Shirdi, Surat, and many other cities." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Do you provide drivers with the car rental?", answer: "Yes, all car rentals include professional and experienced drivers." },
  { question: "Can I book a car for hourly rental?", answer: "Yes, we offer hourly car rental packages for city travel, meetings, and sightseeing." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Mehta",
    feedback:
      "We booked a car rental in Mumbai with Omshree Cabs for our airport transfer. The driver arrived on time and the car was very clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "Excellent car rental service in Mumbai. Easy booking process, professional driver, and smooth travel experience.",
    rating: 5
  }
];
















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Car Rental Mumbai",
  "description": "Omshree Cab provides reliable car rental services in Mumbai for local travel, airport transfers, outstation trips, self-drive options, corporate travel, family trips, weddings, and luxury travel. Choose from a wide range of well-maintained vehicles with transparent per km rates and flexible booking options for a safe and comfortable ride across Mumbai and nearby cities.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2300"
  }
};









  return (
    <div>
      
<Helmet>
  <title>Car Rental Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers car rental services in Mumbai for local travel, airport, outstation, self-drive, corporate, family, wedding, and luxury trips. Well-maintained vehicles, transparent per km rates, and flexible booking options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/55.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Carrentalmumbai;